<template>
    <v-card>
        <v-container grid-list-md>
            <v-layout>
                <v-flex lg3>
                    <v-select :items="freqItems" label="Frekvens" v-model="rrule.freq"/>
                </v-flex>
                <v-flex lg3>
                    <v-text-field type="number" v-model="rrule.count" label="Antall gjentakelser"/>
                </v-flex>
                <v-flex lg3>
                    <v-select multiple :items="weekdayItems" v-model="rrule.byweekday" label="Ukedager"/>
                </v-flex>
                <v-flex lg3>
                    <v-select multiple :items="monthItems" v-model="bymonth" label="Måneder"/>
                </v-flex>
            </v-layout>

            <div>
                <v-subheader class="pl-0">Fra dato:</v-subheader>
                <v-date-picker v-model="dtstart" landscape label="Fra dato" locale="nb" full-width/>
                <v-btn @click="dtstart = null" flat color="red" :disabled="!dtstart">Fjern fra-dato</v-btn>
            </div>
            <div>
                <v-subheader class="pl-0">Til dato:</v-subheader>
                <v-date-picker v-model="until" landscape label="Til dato" locale="nb" full-width/>
                <v-btn @click="until = null" flat color="red" :disabled="!until">Fjern til-dato</v-btn>
            </div>
            <div>
                <v-subheader class="pl-0">Klokkeslett for utsending:</v-subheader>
                <v-time-picker v-model="time" landscape format="24hr" full-width/>
            </div>

            <v-alert :value="true" type="info" class="mt-4">
                <p>
                    Du har valgt:
                    <strong>
                        {{ ruleText }}
                    </strong>
                </p>

                Eksempler (viser inntil 10):
                <ul>
                    <li v-for="date in exampleDates">
                        {{ date.toLocaleDateString() }} kl.
                        {{ date.getUTCHours() }}:{{ (''+date.getUTCMinutes()).padStart(2, '0') }}
                    </li>
                </ul>
            </v-alert>

        </v-container>
    </v-card>
</template>


<script>
    import {RRule} from 'rrule';
    import {rruleToText} from "../helpers";


    export default {
        props: {
            value: {
                type: String,
                default: 'FREQ=DAILY;INTERVAL=1;COUNT=2;BYHOUR=16;BYMINUTE=00'
            }
        },
        created() {
            let rule = RRule.fromString(this.value);
            this.rrule = rule.origOptions;
        },
        data() {
            return {
                rrule: {}
            }
        },
        methods: {
            makeRRule() {
                let rRule = new RRule(this.rrule);
                this.$emit('input', rRule.toString());
                return rRule;
            }
        },
        watch: {
            value() {
                this.rrule = RRule.fromString(this.value).origOptions;
            }
        },
        computed: {
            freqItems() {
                return [
                    {text: 'Årlig', value: RRule.YEARLY},
                    {text: 'Månedlig', value: RRule.MONTHLY},
                    {text: 'Ukentlig', value: RRule.WEEKLY},
                    {text: 'Daglig', value: RRule.DAILY}
                ]
            },
            weekdayItems() {
                return [
                    {text: 'Mandag', value: RRule.MO},
                    {text: 'Tirsdag', value: RRule.TU},
                    {text: 'Onsdag', value: RRule.WE},
                    {text: 'Torsdag', value: RRule.TH},
                    {text: 'Fredag', value: RRule.FR},
                    {text: 'Lørdag', value: RRule.SA},
                    {text: 'Søndag', value: RRule.SU}
                ]
            },
            monthItems() {
                return [
                    {text: 'Januar', value: 1},
                    {text: 'Februar', value: 2},
                    {text: 'Mars', value: 3},
                    {text: 'April', value: 4},
                    {text: 'Mai', value: 5},
                    {text: 'Juni', value: 6},
                    {text: 'Juli', value: 7},
                    {text: 'August', value: 8},
                    {text: 'September', value: 9},
                    {text: 'Oktober', value: 10},
                    {text: 'November', value: 11},
                    {text: 'Desember', value: 12}
                ]
            },
            rule() {
                return this.makeRRule();
            },
            ruleText() {
                return rruleToText(this.rule);
            },
            time: {
                get() {
                    let hour = ('' + this.rrule.byhour).padStart(2, '0');
                    let minute = ('' + this.rrule.byminute).padStart(2, '0');
                    return `${hour}:${minute}`;
                },
                set(val) {
                    let [hour, minute] = val.split(':');
                    this.rrule.byhour = parseInt(hour, 10);
                    this.rrule.byminute = parseInt(minute, 10);
                }
            },
            dtstart: {
                get() {
                    if (!this.rrule.dtstart) return null;
                    return this.rrule.dtstart.toISOString().split('T')[0];
                },
                set(val) {
                    this.rrule = {
                        ...this.rrule,
                        dtstart: new Date(val)
                    }
                }
            },
            until: {
                get() {
                    if (!this.rrule.until) return null;
                    return this.rrule.until.toISOString().split('T')[0];
                },
                set(val) {
                    this.rrule = {
                        ...this.rrule,
                        until: new Date(val)
                    }
                }
            },
            bymonth: {
                get() {
                    let val = this.rrule.bymonth;
                    if (!val) return [];
                    if (Array.isArray(val)) return val;
                    return [val];
                },
                set(val) {
                    if (!Array.isArray(val)) {
                        val = [val];
                    }
                    this.rrule.bymonth = val;
                    this.makeRRule();
                }
            },
            exampleDates() {
                return this.rule.all(function (date, i) {
                    return i < 10;
                });
            }
        }
    }
</script>